module.exports = __webpack_public_path__ + "img/Summer-text.2f0b3421.jpg";